import { gql, useApolloClient, useQuery } from '@apollo/client';
import { useFetch } from 'pages/CampaignPage/CampaignEditPage/ContentPage/utils/useFetch';
import {
  GetCategoryQuery,
  GetCategoryQueryVariables,
  GetRecipeCategoriesChildrenQuery,
  GetRecipeCategoriesChildrenQueryVariables,
  GetRecipeCategoriesQuery,
  GetRecipeCategoriesQueryVariables,
} from '../../__generated__/queries-recipe';

const CATEGORY_CHILDREN_FRAGMENT = gql`
  fragment BrandCategoryFragment on Category {
    id
    title
    level
    status
  }
`;

export const GET_CATEGORIES_CHILDREN = gql`
  query GetRecipeCategoriesChildren($status: String, $brandKey: String) {
    categories(
      where: { status: $status, brandKey: $brandKey, level: 4 }
      first: 150
    ) {
      ...BrandCategoryFragment
      children(first: 150, where: { status: $status }) {
        ...BrandCategoryFragment
        children(first: 150, where: { status: $status }) {
          ...BrandCategoryFragment
          children(first: 150, where: { status: $status }) {
            ...BrandCategoryFragment
          }
        }
      }
    }
  }
  ${CATEGORY_CHILDREN_FRAGMENT}
`;

export const GET_RECIPES_CATEGORIES = gql`
  query GetRecipeCategories(
    $where: CategoryWhereInput!
    $countWhere: RecipeCategoryWhereInput
    $fetchCount: Boolean!
  ) {
    categories(first: 1000, where: $where, orderBy: title_ASC) {
      id
      title
      level
      parent {
        id
      }
      recipeCategoryCount(where: $countWhere) @include(if: $fetchCount)
    }
  }
`;

export const useGetCategories = () => {
  const apolloClient = useApolloClient();

  return (variables: GetRecipeCategoriesQueryVariables) =>
    apolloClient
      .query<GetRecipeCategoriesQuery, GetRecipeCategoriesQueryVariables>({
        query: GET_RECIPES_CATEGORIES,
        variables,
      })
      .then(({ data, errors }) => {
        if (errors?.length) {
          throw errors[0];
        }
        return data;
      });
};

export const GET_CATEGORY = gql`
  query GetCategory($where: CategoryWhereUniqueInput!) {
    category(where: $where) {
      id
      title
    }
  }
`;

export const useGetCategory = (id?: string) =>
  useQuery<GetCategoryQuery, GetCategoryQueryVariables>(GET_CATEGORY, {
    variables: { where: { id } },
    skip: !id,
  });

export const useGetCategoriesChildren = () =>
  useFetch<
    GetRecipeCategoriesChildrenQuery,
    GetRecipeCategoriesChildrenQueryVariables
  >(GET_CATEGORIES_CHILDREN);
